<template>
<div class="chapter">
<div class="inner_page">
<p class="figc"><a id="page3"></a><a id="page4"></a><img alt="" src="images/pg5_1.jpg"/></p>
<p class="ack-title">DEDICATION</p>
<p class="ded">To John, Joey, and Adair,</p>
<p class="ded">You are the brightest stars in my life. May your love and kindness continue to shine through all your lifelong journeys.</p>
<p class="ded">Love, Alex (Mom)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedication.vue?0c191bfb